export const IDLE = "Idle";
export const LOADING = "Loading";
export const SUCCEEDED = "Succeeded";
export const FAILED = "Failed";
